import './App.css';
import React from 'react';
import Router from './app/pages/router';

function App() {

  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
